/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 性別
 */
export type BaseInfoSexEnum =
  (typeof BaseInfoSexEnum)[keyof typeof BaseInfoSexEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoSexEnum = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  UNKNOWN: 'UNKNOWN',
} as const;
